import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import( /* webpackChunkName: "home" */ '@/views/home.vue')
  },
  {
    path: '/node',
    name: 'node',
    component: () => import( /* webpackChunkName: "reward" */ '@/views/reward.vue')
  },
  {
    path: '/nft',
    name: 'nft',
    component: () => import( /* webpackChunkName: "nft" */ '@/views/nft.vue')
  },
  {
    path: '/internet',
    name: 'internet', 
    component: () => import( /* webpackChunkName: "internetCafe" */ '@/views/internetCafe.vue')
  },
  {
    path: '/gamefi',
    name: 'gamefi',
    component: () => import( /* webpackChunkName: "gameFi" */ '@/views/gameFi.vue')
  },
  {
    path: '/question',
    name: 'question',
    component: () => import( /* webpackChunkName: "question" */ '@/views/question.vue')
  },
  {
    path: '/software',
    name: 'software',
    component: () => import( /* webpackChunkName: "software" */ '@/views/software.vue')
  },
  {
    path: '/blog',
    name: 'blog',
    component: () => import( /* webpackChunkName: "blog" */ '@/views/blog.vue')
  },
  {
    path: '/blogInfo/:keyword',
    name: 'blogInfo',
    component: () => import( /* webpackChunkName: "blogInfo" */ '@/views/blogInfo.vue')
  },
  {
    path: '/faq',
    name: 'faq',
    component: () => import( /* webpackChunkName: "faq" */ '@/views/faq.vue')
  },
  {
    path: '/bandWidth',
    name: 'bandWidth',
    component: () => import( /* webpackChunkName: "bandWidth" */ '@/views/bandWidth.vue')
  },
  {
    path: '/bandWidthData',
    name: 'bandWidthData',
    component: () => import( /* webpackChunkName: "bandWidthData" */ '@/views/bandWidthData.vue')
  },
  {
    path: '/paypal',
    name: 'paypal',
    component: () => import( /* webpackChunkName: "paypal_new" */ '@/views/paypal_new.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import( /* webpackChunkName: "NotFound" */ '@/views/NotFound.vue')
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { top: 0 }
  }
})

export default router
